module.exports = __webpack_public_path__ + "img/whatsapp.3cd8990.svg";